export type ListType = 'Dynamic' | 'Internal' | 'Standard' | 'Suppression';
export interface ListTypeMap {
  [key: string]: ListType;
}
export const LIST_TYPES: ListTypeMap = {
  DYNAMIC: 'Dynamic',
  INTERNAL: 'Internal',
  STANDARD: 'Standard',
  SUPPRESSION: 'Suppression',
};
